import { useMemo } from 'react'

import { useSearchParams } from 'react-router-dom'

export type QueryParamsOptions<T extends string> = T[]

/**
 * Custom hook to handle URL query parameters
 * @returns Object containing the query parameters
 */
export const useQueryParams = <T extends string>(options: QueryParamsOptions<T>) => {
  const [searchParams] = useSearchParams()

  const queryParams = useMemo(
    () =>
      options.reduce(
        (acc, key) => {
          acc[key] = searchParams.get(key) || null
          return acc
        },
        {} as Record<T, string | null>
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [options.join(','), searchParams]
  )

  return queryParams
}

export default useQueryParams
